import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme, List } from '@coolblue-development/freddy';
const NavigationList = ({ children, ...rest }) => {
    return (_jsx(List, { sx: {
            overflow: 'hidden',
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            height: freddyTheme.spacing[900],
            gap: `0 ${freddyTheme.spacing[600]}`,
            borderRadius: freddyTheme.borderRadius[100],
            backgroundColor: freddyTheme.color.background.secondary,
            'li, a': {
                display: 'inline-flex',
                alignItems: 'center',
            },
            'li:first-of-type': {
                paddingLeft: freddyTheme.spacing[400],
            },
        }, ...rest, children: children }));
};
export { NavigationList };
//# sourceMappingURL=TopNavigation.styled.js.map